import { pick } from 'underscore';

import { withCurrentParams } from 'actions/utils';
import { BANNER_UPDATE } from 'store/eventConstants';
import { BROADCAST_UPDATE_BANNER } from 'actions/Types';
import { getSceneLayerIds } from 'actions/Broadcast/utils';
import {
  batchUpdateScenes,
  updateSceneLayers
} from '@shoflo/studio-redux/actions';

export default (bannerId, payload) => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const action = {
        type: BROADCAST_UPDATE_BANNER,
        request: async apiClient => {
          const broadcast = await apiClient.broadcast.updateBanner(
            teamId,
            eventId,
            broadcastId,
            bannerId,
            payload
          );

          const {
            meeting: { attendeeResponse },
            broadcastScenes: { scenes }
          } = getState();
          const { banners } = broadcast;
          const sceneLayerIds = getSceneLayerIds(broadcast);
          dispatch(updateSceneLayers(sceneLayerIds));
          // notify other directors
          socket.emit(BANNER_UPDATE, {
            payload,
            bannerId,
            broadcastId,
            notifyingDirector:
              attendeeResponse && attendeeResponse.Attendee.AttendeeId
          });

          const mappedScenes = scenes.reduce((acc, scene) => {
            const { layers } = scene;
            const source = layers.find(layer => layer._id === bannerId);
            if (source) {
              const sceneLayers = layers.map(layer => {
                if (layer._id === bannerId) {
                  const updatedLayer = {
                    ...layer,
                    source: {
                      ...layer.source,
                      value: payload.source.value
                    }
                  };
                  return updatedLayer;
                }
                return layer;
              });
              scene.layers = sceneLayers;
              return [...acc, scene];
            }
            return acc;
          }, []);

          if (mappedScenes.length > 0) {
            const filteredScenes = mappedScenes.map(scene => {
              return pick(scene, [
                '_id',
                'layers',
                'layout',
                'thumbnail',
                'style'
              ]);
            });
            // We dont need to await this response
            batchUpdateScenes(filteredScenes, apiClient, {
              teamId,
              eventId,
              broadcastId
            });
          }

          return banners;
        }
      };
      dispatch(action);
    }
  );
};
